<template>
  <div class="common-background" :style="styleObj"></div>
</template>
<style lang="less">
.common-background {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
<script>
export default {
  props: ["color", "width", "height", "repeat", "image"],
  computed: {
    styleObj() {
      let style =  {
        backgroundColor: this.color||'#000000',
      };
      if(this.image){
          style.backgroundImage = `URL('/api/${this.image}')`;
          style.backgroundSize = `${this.width.value}${this.width.unit} ${this.height.value}${this.height.unit}`;
          style.backgroundRepeat = this.repeat;
      }
      return style;
    }
  }
}
</script>